import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import MenuIcon from '@material-ui/icons/Menu';

import './styles.css';
import {Link} from "react-router-dom";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function TemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >

      <ul className="menu-list">
        <li className="menu-item">
          <a href='#programmation-container'>Programação</a>
        </li>
        <li className="menu-item">
          <a href='#submit-container'>Submissão</a>
        </li>
        <li className="menu-item">
          <a href='#contest-section'>Trabalhos aprovados</a>
        </li>
        <li className="menu-item">
          <a href='#about-section'>Sobre o evento</a>
        </li>
        <li className="menu-item">
          <Link to={'/duvidas'}>Dúvidas</Link>
        </li>
      </ul>
    </div>
  );

  return (
    <div className="menu-icon">
      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <MenuIcon style={{ fontSize: 30, color: "#FFF" }} onClick={toggleDrawer(anchor, true)}>{anchor}</MenuIcon>
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
